import { clsx } from "clsx";

import CollapseArrowIcon from "assets/icons/collapse-arrow.svg?react";
import ExpandArrowIcon from "assets/icons/expand-arrow.svg?react";
import ExpandCollapseIcon from "assets/icons/expand-collapse.svg?react";

export default function ExpandCollapseButton({
  className,
  isExpanded,
  ...rest
}: {
  className: string;
  isExpanded: boolean;
  onClick: () => void;
}) {
  const HoverIcon = isExpanded ? CollapseArrowIcon : ExpandArrowIcon;
  return (
    <button
      type="button"
      className={clsx("group/expand-collapse-button relative", className)}
      {...rest}
    >
      <ExpandCollapseIcon className="group-hover/expand-collapse-button:opacity-0 opacity-100 transition-opacity m-auto" />
      <HoverIcon className="group-hover/expand-collapse-button:opacity-100 opacity-0 absolute inset-0 transition-opacity m-auto" />
    </button>
  );
}
